"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryParamArray = void 0;
const zod_1 = require("zod");
const queryParamArray = (zSchema) => zod_1.z
    .array(zSchema)
    .or(zSchema)
    .optional()
    .transform(value => (typeof value === 'string' ? [value] : value));
exports.queryParamArray = queryParamArray;
